import React from 'react';
import { useSelector } from 'react-redux'
import { isLoaded } from 'react-redux-firebase'
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
 import * as serviceWorker from './serviceWorker';
import { createStore ,applyMiddleware, compose} from 'redux';
import rootReducer from './store/reducer/rootReeducer'
import {Provider } from 'react-redux'
import thunk from 'redux-thunk'
import {createFirestoreInstance,reduxFirestore, getFirestore} from 'redux-firestore'
import { getFirebase} from 'react-redux-firebase'
import { ReactReduxFirebaseProvider } from 'react-redux-firebase'
import fbConfig from './components/config/fbconfig'
import firebase from 'firebase/app'

const store = createStore(
  rootReducer,
  compose(
      applyMiddleware(thunk.withExtraArgument({ getFirestore, getFirebase })),
      reduxFirestore(firebase, fbConfig)
    
  )
);
const rrfProps = {
  firebase,
  config: fbConfig,
  dispatch: store.dispatch,
  createFirestoreInstance
};
const rrfConfig = {
  userProfile: 'users',
  useFirestoreForProfile: true ,
  attachAuthIsReady : true
};

function AuthIsLoaded({ children }) {

  const auth = useSelector(state => state.firebase.auth)

  if (!isLoaded(auth)) return  <center> <div
   className="spinner-border text-info mt-5 my-5 p-3" 
  role="status"
  style={{    top: "50" }}>
  <span className="sr-only  mt-5 my-5 p-3"
  
 >Loading...</span>
</div></center>;

      return children

}

ReactDOM.render(<Provider store={store}> 
  <ReactReduxFirebaseProvider {...rrfProps}> 
  <AuthIsLoaded><App /> </AuthIsLoaded>
  </ReactReduxFirebaseProvider>
  </Provider>, document.getElementById('root'));
  
  serviceWorker.unregister();
  
  